import { Heading } from './ui/Heading'
import { Container, Image } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import React, { FC, HTMLAttributes } from 'react'

type RCPOBannerWithTitleProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  mobileImage: AssetsElement
  desktopImage: AssetsElement
}

export const RCPOBannerWithTitle: FC<RCPOBannerWithTitleProps> = ({
  title,
  mobileImage,
  desktopImage,
  className,
}) => {
  return (
    <div
      className={cn(
        'relative my-14 flex w-full items-center justify-center py-28 md:py-32 lg:my-24 lg:py-80',
        className,
      )}
    >
      <Image
        className="absolute left-0 top-0 h-full w-full object-cover"
        alt={mobileImage.value[0].description || ''}
        sources={[
          getKontentImage(mobileImage.value[0].url, { width: 600 }),
          getKontentImage(desktopImage.value[0].url, { width: 1024 }),
          getKontentImage(desktopImage.value[0].url, { width: 1700 }),
          getKontentImage(desktopImage.value[0].url, { width: 2400 }),
        ]}
        placeholder={getKontentImage(mobileImage.value[0].url, {
          width: 30,
        })}
      />
      <span className="absolute inset-0 z-[2] block h-full w-full bg-rolexShade-900/50" />
      <Container className="z-10 !max-w-[1140px]">
        <Heading variant="large" as="h2" className="text-center text-white">
          {title}
        </Heading>
      </Container>
    </div>
  )
}
